import { useEffect, useState } from 'react';
import { useIntercomAuth } from '@benepass/intercom';
import { useAuthentication } from '../data/auth/transition';
import current from '../config';

export const useEmployeeIntercomAuth = () => {
  const { getAccessToken, isAuthenticated, user } = useAuthentication();

  // Get the auth token when user is authenticated
  const [authToken, setAuthToken] = useState<string | null>(null);
  useEffect(() => {
    if (isAuthenticated) {
      getAccessToken().then(setAuthToken);
    } else {
      setAuthToken(null);
    }
  }, [isAuthenticated, getAccessToken]);

  // Only show Intercom for @getbenepass.com emails during pilot
  const shouldUseIntercom = user?.email?.includes('@getbenepass.com');
  useIntercomAuth(shouldUseIntercom ? authToken : null, current.api.origin);
};
